
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as improvekmpJ5T7Vb2t4aYMMvzcTaC3DE3y1Lu836ZPsRMSZXwcMeta } from "/home/runner/_work/mono/mono/out/apps/web/app/pages/campaigns/[icp]/improve.vue?macro=true";
import { default as settingsbi2thYYnzMv2hXyxa5MwwP3n1HdlDhurEo0gZ82RmpgMeta } from "/home/runner/_work/mono/mono/out/apps/web/app/pages/settings.vue?macro=true";
export default [
  {
    name: "campaigns-edit-icp",
    path: "/campaigns/edit/:icp()",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/campaigns/edit/[icp].vue")
  },
  {
    name: "campaigns-review-icp",
    path: "/campaigns/review/:icp()",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/campaigns/review/[icp].vue")
  },
  {
    name: "admin-campaigns",
    path: "/admin/campaigns",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/admin/campaigns.vue")
  },
  {
    name: "admin-chats",
    path: "/admin/chats",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/admin/chats.vue")
  },
  {
    name: "admin-emailbison",
    path: "/admin/emailbison",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/admin/emailbison.vue")
  },
  {
    name: "admin-linkedin",
    path: "/admin/linkedin",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/admin/linkedin.vue")
  },
  {
    name: "admin-mailboxes",
    path: "/admin/mailboxes",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/admin/mailboxes.vue")
  },
  {
    name: "admin-organizations",
    path: "/admin/organizations",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/admin/organizations.vue")
  },
  {
    name: "admin-reconciler",
    path: "/admin/reconciler",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/admin/reconciler.vue")
  },
  {
    name: "admin-research",
    path: "/admin/research",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/admin/research.vue")
  },
  {
    name: "admin-tickets",
    path: "/admin/tickets",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/admin/tickets.vue")
  },
  {
    name: "admin-vendor-usage",
    path: "/admin/vendor-usage",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/admin/vendor-usage.vue")
  },
  {
    name: "saved-all",
    path: "/saved/all",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/saved/all.vue")
  },
  {
    name: "saved-mine",
    path: "/saved/mine",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/saved/mine.vue")
  },
  {
    name: "accounts-id",
    path: "/accounts/:id()",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/accounts/[id].vue")
  },
  {
    name: "campaigns-icp",
    path: "/campaigns/:icp()",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/campaigns/[icp].vue"),
    children: [
  {
    name: "campaigns-icp-activities",
    path: "activities",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/campaigns/[icp]/activities.vue")
  },
  {
    name: "campaigns-icp-companies",
    path: "companies",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/campaigns/[icp]/companies.vue")
  },
  {
    name: "campaigns-icp-contacts",
    path: "contacts",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/campaigns/[icp]/contacts.vue")
  },
  {
    name: "campaigns-icp-conversion",
    path: "conversion",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/campaigns/[icp]/conversion.vue")
  },
  {
    name: "campaigns-icp-improve",
    path: "improve",
    meta: improvekmpJ5T7Vb2t4aYMMvzcTaC3DE3y1Lu836ZPsRMSZXwcMeta || {},
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/campaigns/[icp]/improve.vue")
  },
  {
    name: "campaigns-icp-inbox",
    path: "inbox",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/campaigns/[icp]/inbox.vue")
  },
  {
    name: "campaigns-icp-opens",
    path: "opens",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/campaigns/[icp]/opens.vue")
  },
  {
    name: "campaigns-icp-overview",
    path: "overview",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/campaigns/[icp]/overview.vue")
  },
  {
    name: "campaigns-icp-review",
    path: "review",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/campaigns/[icp]/review.vue")
  },
  {
    name: "campaigns-icp-stats",
    path: "stats",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/campaigns/[icp]/stats.vue")
  },
  {
    name: "campaigns-icp-targeting",
    path: "targeting",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/campaigns/[icp]/targeting.vue")
  }
]
  },
  {
    name: "chat-id",
    path: "/chat/:id()",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/chat/[id].vue")
  },
  {
    name: "companies-domain",
    path: "/companies/:domain()",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/companies/[domain].vue")
  },
  {
    name: "contacts-id",
    path: "/contacts/:id()",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/contacts/[id].vue")
  },
  {
    name: "saved-listId",
    path: "/saved/:listId()",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/saved/[listId].vue")
  },
  {
    name: "activity",
    path: "/activity",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/activity.vue")
  },
  {
    name: "campaigns",
    path: "/campaigns",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/campaigns/index.vue")
  },
  {
    name: "chat",
    path: "/chat",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/chat/index.vue")
  },
  {
    name: "insights",
    path: "/insights",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/insights.vue")
  },
  {
    name: "opens",
    path: "/opens",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/opens.vue")
  },
  {
    name: "owner-performance",
    path: "/owner-performance",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/owner-performance.vue")
  },
  {
    name: "performance",
    path: "/performance",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/performance.vue")
  },
  {
    name: "replies",
    path: "/replies",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/replies.vue")
  },
  {
    name: "scheduled",
    path: "/scheduled",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/scheduled.vue")
  },
  {
    name: settingsbi2thYYnzMv2hXyxa5MwwP3n1HdlDhurEo0gZ82RmpgMeta?.name,
    path: "/settings",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/settings.vue"),
    children: [
  {
    name: "settings-account",
    path: "account",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/settings/account.vue")
  },
  {
    name: "settings-calendar",
    path: "calendar",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/settings/calendar.vue")
  },
  {
    name: "settings-chat-sources",
    path: "chat-sources",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/settings/chat-sources.vue")
  },
  {
    name: "settings-crm",
    path: "crm",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/settings/crm.vue")
  },
  {
    name: "settings-crm-ampersand",
    path: "crm-ampersand",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/settings/crm-ampersand.vue")
  },
  {
    name: "settings-developer",
    path: "developer",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/settings/developer.vue")
  },
  {
    name: "settings-engaged-contacts",
    path: "engaged-contacts",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/settings/engaged-contacts.vue")
  },
  {
    name: "settings-exports",
    path: "exports",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/settings/exports.vue")
  },
  {
    name: "settings-forbidden-accounts",
    path: "forbidden-accounts",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/settings/forbidden-accounts.vue")
  },
  {
    name: "settings-forbidden-contacts",
    path: "forbidden-contacts",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/settings/forbidden-contacts.vue")
  },
  {
    name: "settings-imports",
    path: "imports",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/settings/imports.vue")
  },
  {
    name: "settings-linkedin",
    path: "linkedin",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/settings/linkedin.vue")
  },
  {
    name: "settings-mailbox",
    path: "mailbox",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/settings/mailbox.vue")
  },
  {
    name: "settings-members",
    path: "members",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/settings/members.vue")
  },
  {
    name: "settings-notifications",
    path: "notifications",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/settings/notifications.vue")
  },
  {
    name: "settings-organization",
    path: "organization",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/settings/organization.vue")
  },
  {
    name: "settings-outbound-manager",
    path: "outbound-manager",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/settings/outbound-manager.vue")
  },
  {
    name: "settings-replies",
    path: "replies",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/settings/replies.vue")
  },
  {
    name: "settings",
    path: "",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/settings/index.vue")
  }
]
  },
  {
    name: "signin",
    path: "/signin",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/signin.vue")
  },
  {
    name: "index",
    path: "/",
    redirect: "/campaigns",
    component: () => import("/home/runner/_work/mono/mono/out/apps/web/app/pages/index.vue")
  }
]